<template>
  <!--左侧筛选-->
  <div class="leftSettingMain">
    <div class="settingTit flex">
      <span class="flexItem">筛选条件</span>
      <a class="reset">重置</a>
    </div>
    <div
      v-for="(group, index) of this.filters"
      :key="index"
      class="settingItem"
    >
      <h6>{{ group.title }}</h6>
      <div v-if="group.title == '培训周期'">
        <label
          v-for="(item, index) of group.list"
          :key="index"
          class="labelMin"
        >
          <input
            type="checkbox"
            :value="item.id"
            v-model="this.checkedFilters.trainCycle"
          />{{ item.name }}</label
        >
      </div>
      <div v-if="group.title == '学段'">
        <label
          v-for="(item, index) of group.list"
          :key="index"
          class="labelMin"
        >
          <input
            type="checkbox"
            :value="item.name"
            v-model="this.checkedFilters.period"
          />{{ item.name }}</label
        >
      </div>
      <div v-if="group.title == '课程费用'">
        <label
          v-for="(item, index) of group.list"
          :key="index"
          class="labelMin"
        >
          <input
            type="checkbox"
            :value="item.id"
            v-model="this.checkedFilters.money"
          />{{ item.name }}</label
        >
      </div>
      <div v-if="group.title == '课程类型'">
        <label
          v-for="(item, index) of group.list"
          :key="index"
          class="labelLarge"
        >
          <input
            type="checkbox"
            :value="item.id"
            v-model="this.checkedFilters.type"
          />{{ item.name }}</label
        >
      </div>
    </div>
    <div v-if="this.otherFilter.title != null" class="settingItem">
      <h6>{{ this.otherFilter.title }}</h6>
      <label class="labelLarge">
        <input
          type="checkbox"
          :value="this.otherFilter.item.name"
          v-model="this.checkedFilters.other"
        />{{ this.otherFilter.item.name }}</label
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      otherFilter: {}, // 可能存在的扩展筛选条件
      checkedFilters: {
        trainCycle: [], // 培训周期
        type: [], // 类型
        money: [], // 费用
        period: [], // 学段
        other: [], // 扩展条件
      },
    };
  },
  mounted() {
    // 根据传入的参数设置选择器状态
    if (this.initClassify == "") return;
    // 检查传入的参数是否是教师选择器，如果是，则不展示；否则继续判断下一步
    let teacherFilters = this.$store.state.courseCenterTopFilters;
    if (teacherFilters == null) {
      return;
    } else {
      for (const filter of teacherFilters) {
        if (filter.name == this.initClassify) {
          return;
        }
      }
    }
    // 检查传入的参数是否是学段选择器，如果是，则设置状态，否则追加到末尾
    let isChecked = false;
    for (const filter of this.filters) {
      if (filter.title == "学段") {
        for (const filterItem of filter.list) {
          if (filterItem.name == this.initClassify) {
            // 设置为已勾选
            isChecked = true;
            // 判断是否已经包含初始分类
            if (this.checkedFilters.period.indexOf(this.initClassify) < 0) {
              this.checkedFilters.period.push(filterItem.name);
            }
            break;
          }
        }
      }
      if (isChecked) {
        // 跳出外层循环
        break;
      }
    }
    if (!isChecked) {
      // 添加一个额外条件
      this.checkedFilters.other = [this.initClassify];
      this.otherFilter = {
        title: "条件",
        item: { name: this.initClassify },
      };
    }
  },
  computed: {
    filters() {
      return this.$store.state.courseCenterSideFilters;
    },
    // 页面初始化时可能从外部传入的类型
    initClassify() {
      return this.$route.query.c == null ? "" : this.$route.query.c;
    },
  },
  watch: {
    checkedFilters: {
      deep: true,
      handler() {
        this.$emit("sideFilters", this.checkedFilters);
      },
    },
  },
};
</script>

<style scoped>
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.flexItem {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.leftSettingMain {
  background-color: #fff;
  width: 260px;
  padding: 0px 30px 30px 30px;
  overflow-y: auto;
  border-right: 1px solid rgba(237, 237, 237, 1);
  z-index: 2;
  float: left;
}

.settingTit {
  height: 52px;
  line-height: 52px;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
}

.settingTit span {
  color: rgba(0, 0, 0, 0.75);
  font-weight: 600;
  font-size: 14px;
}

.settingTit .reset {
  color: rgba(2, 88, 173, 1);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.settingTit .reset:hover {
  color: var(--link-hover-color);
}

.settingItem {
  margin-top: 15px;
  font-size: 0;
}

.settingItem h6 {
  color: rgba(0, 0, 0, 0.75);
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 10px;
}

.settingItem .labelMin {
  display: inline-block;
  width: 50%;
  text-align: left;
  margin-bottom: 8px;
  color: rgba(35, 51, 64, 1);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.settingItem .labelLarge {
  display: inline-block;
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
  color: rgba(35, 51, 64, 1);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.settingItem label:hover {
  color: var(--link-hover-color);
}

.settingItem input[type="checkbox"] {
  width: 20px;
  height: 20px;
  vertical-align: sub;
  margin-right: 10px;
}
</style>